import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=43855b4c&scoped=true"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=43855b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43855b4c",
  null
  
)

export default component.exports